import { render } from "./QuickActionsButton.vue?vue&type=template&id=01825080"
import script from "./QuickActionsButton.vue?vue&type=script&lang=js"
export * from "./QuickActionsButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__